module.exports = __webpack_public_path__ + "40e74ab31806b6aa587346c0c9d42162.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/backgroundСomments.png
// module id = 3235
// module chunks = 0